import React, { Component } from 'react';
import radium, { Style } from 'radium';

import SideMenuSlider from '../../../../../../../components/SideMenuSlider';
import blockTypes from './types';
import BlockTypeItem from './BlockTypeItem';
// import Relay from 'react-relay/classic';

const styles = getStyles(); // eslint-disable-line no-use-before-define

class AddBlockMenu extends Component {
  state = {
    activeIndex: 0
  };

  expandToggle = (index, activeIndex) => () => {
    if (index === activeIndex) {
      return this.setState({ activeIndex: -1 });
    }
    return this.setState({ activeIndex: index });
  };

  onSelect = (type, family, variant) => () => {
    const { closeSideMenu } = this.props;
    closeSideMenu();
    this.props.onTypeSelect(type, family, variant);
  };

  renderBlockTypeList = () => blockTypes.map((t, i) => (
    <BlockTypeItem
      type={t}
      index={i}
      open={i === this.state.activeIndex}
      key={i}
      onButtonClick={this.expandToggle(i, this.state.activeIndex)}
      onSelect={this.onSelect}
    />
  ));

  render() {
    const { openMenu, closeSideMenu } = this.props;
    return (
      <div className="AddBlockMenuContainer">
        <SideMenuSlider
          side="left"
          open={openMenu}
          closeSideMenu={closeSideMenu}
          closeIconColor="#fff"
          closeButtonStyle={styles.closeButtonStyle}
          style={styles.sideMenuStyle}
          contentContainerStyle={styles.contentContainerStyle}
        >
          <div className="menuTitle">ADD CONTENT</div>
          <div className="typesContainer">{this.renderBlockTypeList()}</div>
        </SideMenuSlider>
        <Style rules={styles.classBased} scopeSelector=".AddBlockMenuContainer" />
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {
      '': {
        fontFamily: 'ProximaNova'
      },
      '.menuTitle': {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        background: '#313538',
        padding: '14px 20px',
        color: '#fff',
        fontWeight: '500',
        fontSize: '14px'
      },
      '.BlockTypeItem': {
        cursor: 'pointer'
      },
      '.variantImage img': {
        maxWidth: '100%',
        height: 'auto',
        display: 'block'
      },
      '.typeButton': {
        background: '#fff',
        color: '#0e0e0e',
        fontSize: '16px',
        fontWeight: '400',
        padding: '8px 20px 8px 30px',
        cursor: 'pointer',
        borderTop: '1px solid rgba(14, 14, 14, 0.06)',
        borderBottom: '1px solid rgba(14, 14, 14, 0.06)'
      },
      '.typeLabel': {
        padding: '0 0 0 7px'
      },
      '.variantItemsContainer': {
        maxHeight: 'calc(100vh - 344px)',
        overflow: 'auto'
      }
    },
    sideMenuStyle: {
      width: '300px',
      background: '#f5f5f5'
    },
    closeButtonStyle: {
      top: '15px',
      zIndex: '1'
    },
    contentContainerStyle: {
      paddingLeft: '0',
      paddingRight: '0',
      paddingTop: '49px'
    }
  };
}

export default radium(AddBlockMenu);
